// extracted by mini-css-extract-plugin
export default {"value":"ProvisionTypeSelectOption-module__value--LTPIQ","badgeWrapper":"ProvisionTypeSelectOption-module__badgeWrapper--pk2AZ"};